import appConfig from "../../../config/appConfig";

const SAFE_ENTRY_ROUTES = new Set([
  "/menu/academy",
  "/menu/dashboard",
]);

export async function resolveAcademyEntryRoute(accessToken) {
  if (!accessToken) return "/menu/dashboard";

  try {
    const response = await fetch(
      `${appConfig.API_BASE_URL}/api/system/academy-workflow/entry`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        credentials: "include",
      },
    );
    if (!response.ok) return "/menu/dashboard";

    const data = await response.json();
    return SAFE_ENTRY_ROUTES.has(data?.recommended_route)
      ? data.recommended_route
      : "/menu/dashboard";
  } catch {
    return "/menu/dashboard";
  }
}
